import {MechanicalPreferencesJson, SelectionRequestJson} from "../../business/ApiJsonTypes";

const PREFERRED_SELECTION_CRITERIA_KEY = "preferredSelectionCriteria";

export function readPreferredSelectionCriteria(): SelectionRequestJson | null {
    const stored = sessionStorage.getItem(PREFERRED_SELECTION_CRITERIA_KEY);
    if (stored === null) {
        return null;
    }
    const criteria: SelectionRequestJson | null = JSON.parse(stored);
    if (criteria !== null && criteria.mechanicalPreferences.customShaftThreadPreference === undefined) {
        // Backward compatibility for criteria persisted before the thread preference field existed
        criteria.mechanicalPreferences.customShaftThreadPreference = null;
    }
    return criteria;
}

export function writePreferredSelectionCriteria(criteria: SelectionRequestJson): void {
    sessionStorage.setItem(PREFERRED_SELECTION_CRITERIA_KEY, JSON.stringify(criteria));
}

export function clearPreferredSelectionCriteria(): void {
    sessionStorage.removeItem(PREFERRED_SELECTION_CRITERIA_KEY);
}

/**
 * Overlays the shaft/mechanical decisions made in the mechanical configurator onto already
 * remembered selection criteria, leaving the rest (working point, environment, blade profiles)
 * untouched. customShaftThreadPreference and wymiaryPrzylaczenioweZatwierdzone stay as in base
 * because the selection form owns those, not the configurator.
 */
export function withMechanicalConfigurationApplied(base: SelectionRequestJson,
                                                   mechanicalPreferences: MechanicalPreferencesJson,
                                                   realizeWithClutch: boolean): SelectionRequestJson {
    return {
        ...base,
        mechanicalPreferences: {
            ...base.mechanicalPreferences,
            fanMountingOrientationCode: mechanicalPreferences.fanMountingOrientationCode,
            airflowRelativeClutchMountingSideCode: mechanicalPreferences.airflowRelativeClutchMountingSideCode,
            preferredSupportAndClutchDiscSideCode: mechanicalPreferences.preferredSupportAndClutchDiscSideCode,
            shaftDiameter: mechanicalPreferences.shaftDiameter,
            shaftLength: mechanicalPreferences.shaftLength,
            expectedImpellerHeight: mechanicalPreferences.expectedImpellerHeight,
        },
        realizeWithClutch,
    };
}
